import { Clipboard } from '@angular/cdk/clipboard'
import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { AuthService } from '@app/modules/auth/services/auth.service'
import { Persona } from '@app/modules/personas/interfaces/persona.interface'
import { environment } from '@environments/environment'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'

@Component({
  selector: 'ngx-landing-embed-code',
  templateUrl: './landing-embed-code.component.html',
  styleUrls: ['./landing-embed-code.component.scss'],
  imports: [CommonModule, NgxSkeletonLoaderModule]
})
export class LandingEmbedCodeComponent implements OnInit {
  @Input() eventSlug: string
  @Input() form: Persona
  @Input() isLoading = false

  formLinkStatus: string
  isCopying = false

  readonly skeletonTheme = {
    width: '100%',
    height: '72px',
    'border-radius': '12px',
    backgroundColor: '#e5e7eb',
    color: '#d1d5db',
    margin: '0'
  }

  constructor(private clipboard: Clipboard, private auth: AuthService) {}

  ngOnInit(): void {}

  /**
   * Copy code and toggle status display
   */
  copyCode(): void {
    if (this.isCopying || !this.eventSlug || !this.form?.slug) return

    this.isCopying = true
    this.formLinkStatus = 'Copied to Clipboard'
    this.clipboard.copy(this.embeddedForm)
    setTimeout(() => {
      this.formLinkStatus = undefined
      this.isCopying = false
    }, 500)
  }

  /**
   * Get embedded from
   * @returns string
   */
  get embeddedForm(): string {
    if (!this.eventSlug || !this.form?.slug || !this.form?.name) return ''
    const personaName = this.form?.name[0].toUpperCase() + this.form?.name.slice(1)
    return `<div style="width:100%;"><script type="text/javascript" src="${environment.baseFormsUrl}/form.min.js"></script><a class="contactless-registration-widget" data-width="100%" data-height="100%" href="${environment.publicFormsUrl}workspaces/${this.auth.currentWorkspace.slug}/events/${this.eventSlug}/forms/${this.form?.slug}?ctl_campaign=${this.eventSlug}&focus=false">${personaName} Registration</a>
        <script type="text/javascript">
      addEventListener("message", (e) => {
        const _l = "${environment.baseFormsUrl}";
        if (_l === e.origin && e.data.redirectUrl) window.top.location.href = e.data.redirectUrl;
      });
    </script></div>`
  }
}
